export default {
    patientInfo : "",
    patient_id : "",
};
